import React from "react";
import { Box, Typography, Container, Paper } from "@mui/material";

const TermsOfUse = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>Terms of Use</Typography>

  <Typography paragraph>
    Welcome to "Share a Secret". This service allows users to share sensitive information securely and anonymously.
  </Typography>

  <Typography paragraph>
    Share a Secret is not responsible for the content of any secret shared through the platform, nor are we liable for any loss or damage that may arise due to the loss or misuse of a secret. The responsibility for the content and its management remains solely with the creator of the secret. We do not monitor, control, or have access to the contents of the secrets, and once deleted, the secret cannot be recovered.
  </Typography>

  <Typography paragraph>
    Share a Secret does not know the purpose for which a secret is being used. The creator of the secret is solely responsible for its use and distribution. We do not collect any information regarding the intended use or reason behind the creation of a secret. Our platform only facilitates the secure sharing of secrets and ensures that they are encrypted and managed according to the settings defined by the creator.
  </Typography>

  <Typography variant="h6" gutterBottom>1. Purpose of the Service</Typography>
  <Typography paragraph>
    Our platform acts only as a temporary exchange medium for secrets. We are not responsible for the content or usage of the shared secrets.
  </Typography>

  <Typography variant="h6" gutterBottom>2. Anonymity and Privacy</Typography>
  <Typography paragraph>
    We do not store personally identifiable information such as raw IP addresses. For abuse prevention, our servers temporarily process a one-way hashed identifier derived from your network address for rate limiting; the raw address is never stored and the hash is deleted automatically after a short period. The only other exception is when email link authentication is used. In that case, a temporary Firebase Authentication account is created solely for access control using the provided email address. No other data is stored.
  </Typography>

  <Typography variant="h6" gutterBottom>3. Email Link Authentication</Typography>
  <Typography paragraph>
    When enabled, recipients confirm access via a secure email link. A Firebase account is temporarily created for this purpose, and only the email address is stored. If the creator restricts a secret to a specific email address, that address is stored alongside the secret solely to enforce the restriction. We do not otherwise track who accessed which secret.
  </Typography>

  <Typography variant="h6" gutterBottom>4. Account Creation</Typography>
  <Typography paragraph>
    Creating secrets requires no account. If email-based protection is enabled, recipients must verify their address. These temporary accounts are automatically deleted after 30 days of inactivity.
  </Typography>

  <Typography variant="h6" gutterBottom>5. Data Security & Privacy</Typography>
  <Typography paragraph>
    We use Firebase infrastructure. All secrets are end-to-end encrypted. The encryption key is stored in the URL fragment (after the <code>#</code>) and is not automatically transmitted to the server. However, it may leave your device if you share the full link or your browser environment allows it.
  </Typography>

  <Typography variant="h6" gutterBottom>6. What data is stored alongside a secret?</Typography>
  <Typography paragraph>
    We store metadata such as creation date, access limits, expiration dates, and email requirement flags. This data never includes secret content or identity of the creator.
  </Typography>

  <Typography variant="h6" gutterBottom>7. Secret Expiration</Typography>
  <Typography paragraph>
    Secrets are deleted if unused for 30 days, if the view limit is reached, or the expiration time is passed. This deletion is irreversible.
  </Typography>

  <Typography variant="h6" gutterBottom>8. No Tracking or Analytics</Typography>
  <Typography paragraph>
    We do not use cookies or analytics, except one cookie for color mode and temporary cookies for email authentication, which are removed on browser close.
  </Typography>

  <Typography variant="h6" gutterBottom>9. Changes to the Terms</Typography>
  <Typography paragraph>
    We reserve the right to update these terms. Continued use implies agreement to the latest version.
  </Typography>

  <Typography paragraph>
    Last updated: July 1, 2026
  </Typography>
      </Paper>
    </Container>
  );
};

export default TermsOfUse;
